<!-- 
分類の一覧画面
@props
  itemList : 分類の配列
  canAddCategory : 分類を追加できる状態であればtrue、そうでなければfalseを指定する
-->

<template>
  <div>
    <div class="ml-2 text-h5">広島県のお知らせ分類</div>
    <v-data-table
      locale="jp"
      mobile-breakpoint="0"
      v-model="selected"
      :headers="headers"
      :items="itemList"
      :custom-sort="sortFunction"
      item-key="recordId"
      show-select
      hide-default-footer
      :single-select="false"
      :search="searchCondition"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      no-results-text="検索条件に合うデータがありません"
      no-data-text="データがありません"
    >
      <!-- 表ヘッダ部のボタン -->
      <template v-slot:top>
        <v-btn
          color="primary"
          class="ma-2"
          @click="create"
          :disabled="false"
        >
          新規登録
        </v-btn>

        <v-menu bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="ma-2"
              v-bind="attrs"
              v-on="on"
              :disabled="!selectionStatus.includes('contain.any')"
            >
              操作 <v-icon>mdi-chevron-down</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              :disabled="!selectionStatus.includes(item.condition)"
              @click="item.event"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- ヘッダの定義 -->
      <template v-slot:[`header.data-table-select`]="{ props, on }">
        <v-simple-checkbox
          v-if="false"
          :value="props.value || props.indeterminate"
          v-on="on"
          :indeterminate="props.indeterminate"
          dark
          :ripple="false"
        />
      </template>
      <template
        v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
      >
        <v-simple-checkbox
          v-if="item.categoryEdit.editable"
          :value="isSelected"
          @input="select($event)"
          @click="selectedCheckbox(item)"
          :ripple="false"
        >
        </v-simple-checkbox>
      </template>
      <!-- テーブルのコンテンツの定義 -->
      <template v-slot:[`item.category`]="{ item }">
        <td class="fixed-width-300 text-truncate">{{ item.category }}</td>
      </template>
      <template v-slot:[`item.restricted`]="{ item }">
        <v-icon
          color="blue darken-1"
          @click="moveItem(item.recordId, true)"
          :disabled="item.order === 1" 
          style="cursor: pointer;"
        >
          mdi-arrow-up
        </v-icon>
        <v-icon
          color="red darken-1"
          @click="moveItem(item.recordId, false)"
          :disabled="item.order === itemList.length"
          style="cursor: pointer;"
        >
          mdi-arrow-down
        </v-icon>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
    <!-- 確認ダイアログ -->
    <confirm-dialog ref="confirm_category_delete" @on-click-ok="deleteCategory">
      分類を削除します。よろしいですか？
    </confirm-dialog>
    <confirm-dialog
      ref="confirm_category_edit"  @on-click-ok="editCategory">
      分類を編集します。よろしいですか？
    </confirm-dialog>
    <confirm-dialog ref="confirm_category_cannot_delete" @on-click-ok="Category">
      この分類を設定したお知らせが登録されているため削除できません。
    </confirm-dialog>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import ConfirmDialog from "../dialog/confirm.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueConverter from "../../logic/common/value-converter";
import valueMapper from "../../logic/common/value-mapper";
export default {
  props: ["itemList", "canAddCategory"],
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  computed: {
    /**
     * チェックボックスの選択状態
     */
    selectionStatus() {
      if (this.selectedCategoryList.length == 0) {
        return [];
      }
      return ["contain.any"];
    },
    /**
     * チェックボックスで選択したアカウントの一覧
     */
    selectedCategoryList() {
      return this.selected.filter((item) => item.categoryEdit.editable);
    },
  },
  data() {
    return {
      // 検索条件（入力中）
      search: "",
      // 検索条件（一覧反映中）
      searchCondition: "",
      // 表示中のページ番号
      page: 1,
      // ページ数
      pageCount: 0,
      // ページあたりに表示するユーザー件数
      itemsPerPage: 20,
      // 選択中のユーザー情報
      selected: [],
      // 一覧のヘッダ定義
      headers: [
        {
          text: "分類",
          align: "start",
          value: "category",
          class: "grey darken-1 white--text",
          width: "300px",
        },
        {
          text: "表示順",
          align: "start",
          value: "restricted",
          class: "grey darken-1 white--text",
          width: "300px",
        },
      ],
      // 操作ボタンを押した時に表示するメニューの一覧
      items: [
        {
          title: "編集",
          condition: "contain.any",
          event: () => {
            // 分類を編集する
            this.editCategory();
          },
        },
        {
          title: "削除",
          condition: "contain.any",
          event: () => {
            // 分類を削除する
            console.log("this.selectedCategoryList[0].usedNumber = " + this.selectedCategoryList[0].usedNumber);
            if (this.selectedCategoryList[0].usedNumber == 0) {
              this.$refs.confirm_category_delete.showDialog();
            } else {
              this.$refs.confirm_category_cannot_delete.showDialog();
            }
          },
        },
      ],
    };
  },
  methods: {
    /**
     * 並び替えをカスタマイズする
     */
    sortFunction(items, sortBy, sortDesc) {
      if (sortBy.length == 0) {
        const userGroupIds = this.$store.getters.userGroupIds;
        return valueConverter.dataTableCustomSort(
          items,
          ["groupName"],
          [false],
          (a, b) => {
            // ログインユーザーの所属グループと同じIDであれば先頭に表示する
            if (userGroupIds.includes(a.groupId)) {
              return -1;
            }
            if (userGroupIds.includes(b.groupId)) {
              return 1;
            }
            // ログインユーザー以外のユーザーはデフォルトの比較方法で判定を行う
            return undefined;
          }
        );
      }
      return valueConverter.dataTableDefaultSort(items, sortBy, sortDesc);
    },
    /**
     * 分類を編集する
     */
    editCategory() {
      console.log("this.selected[0].recordId");
      console.log(this.selected[0].recordId);
      this.$router.push(`/prefcategory/edit/${this.selected[0].recordId}`);
    },
    /**
     * 分類を作成する
     */
    create() {
      this.$router.push("/prefcategory/edit/create");
    },
    /**
     * 所属グループ管理者の全て開くボタン（全て開く/全て閉じる）が押下された
     */
    onChangeAdminState(state) {
      console.log("onChangeAdminState");
      console.log(state);
      Object.keys(this.$refs)
        .filter((key) => key.startsWith("adminTooltips."))
        .forEach((key) => {
          const item = this.$refs[key];
          if (item) {
            item.setEllipsisState(!state);
          }
        });
    },
    /**
     * 所属閲覧者の全て開くボタン（全て開く/全て閉じる）が押下された
     */
    onChangeUserState(state) {
      console.log("onChangeUserState");
      console.log(state);
      Object.keys(this.$refs)
        .filter((key) => key.startsWith("userTooltips."))
        .forEach((key) => {
          const item = this.$refs[key];
          if (item) {
            item.setEllipsisState(!state);
          }
        });
    },
    /**
     * カテゴリを削除する
     */
    deleteCategory() {
      this.$emit("on-delete-category", this.selectedCategoryList);
      this.selected = [];
    },
    /**
     * 権限を付与する
     */
    attachPermision() {
      // 遅延チェックフラグを立てる
      // 遅延チェック（メールアドレス形式の検証）を有効にする
      this.delayCheck = true;
      if (this.$v.permission_mail_address.$invalid) {
        // もし入力に検証エラーがあればダイアログを閉じない
        return;
      }

      this.$emit(
        "on-attach-permission",
        this.selectedGroupList,
        this.permission_mail_address,
        this.permission_selected
      );
      this.selected = [];

      //ダイアログを閉じる
      this.$refs.confirm_attach_permission.hideDialog();
    },
    selectedCheckbox(item) {
      if (this.selected.length >= 1) {
        if (this.selected[0].recordId != item.recordId){
          this.selected = [];
          this.selected[0] = item;
        } else {
          this.selected = [];          
        }
      }
    },
    moveItem(recordId, direction) {     
      // 現在のアイテムのインデックスを検索
      const currentIndex = this.itemList.findIndex(item => item.recordId === recordId);
      // 入れ替えが可能な範囲内か確認
      if (currentIndex === -1) return; // recordIdが見つからない場合は何もしない
      // direction に基づいて新しいインデックスを計算
      const newIndex = direction ? currentIndex - 1 : currentIndex + 1;
      // newIndex が範囲内か確認
      if (newIndex >= 0 && newIndex < this.itemList.length) {
        // DBのデータの入れ替え
        this.changeOrder(recordId, direction);
        // 表示アイテムの入れ替え
        const temp = this.itemList[currentIndex];
        this.$set(this.itemList, currentIndex, this.itemList[newIndex]);
        this.$set(this.itemList, newIndex, temp);
        // order プロパティを更新
        const tempOrder = this.itemList[currentIndex].order;
        this.itemList[currentIndex].order = this.itemList[newIndex].order;
        this.itemList[newIndex].order = tempOrder;
      }
    },
    /**
     * 順番を入れ替える
     */
    changeOrder(recordId, direction) {
      console.log("changeOrder()");
      // リクエストパラメータを作成する
      let updateUrl = "";
      let postData = null;
      updateUrl = "/admin/hiroshima/information/category/changeorder";
      postData = {
        record_id: recordId,
        direction: direction,
      };
      // APIを実行する
      this.$store.commit("setWaiting", true);
      console.log("updateUrl = " + updateUrl);
      console.log("postData = " + JSON.stringify(postData));
      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/prefcategory");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          console.log("error = " + error);
          console.log("error.status = " + error.status);
          if (error == "SyntaxError: Unexpected end of JSON input") {
            console.log("JSONエラーは後で確認");
            this.$store.commit("setWaiting", false);
            this.$router.push("/prefcategory");
          }
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
  },
};
</script>

<style>
th {
  background-color: #757575 !important;
}
th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}
th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
